import React, { useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { salesTargetGetById } from "./grphql";
import MaterialButton from "../../components/MaterialButton";

const ViewMonthlyTarget = () => {
  const [oneUserData, setOneUserData] = useState(null);
  const [id, setId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const pathid = location.search.slice(1);

  useEffect(() => {
    fetchdata();
    setId(pathid);
  }, [id, pathid]);
  
 

  const fetchdata = async () => {
    try {
      const res = await request(BASEURL, salesTargetGetById, { id: id });
      setOneUserData(res?.salesTargetGetById);
    } catch (err) {
    } finally {
    }
  };

  const handleAddMonthly = () => {
    navigate(`/SalesTarget/singlepersontarget?${id}`);
  };
  return (
    <DashboardLayout>
      <div>
        <div>
          <table className="montable">
            <thead>
              <tr className="montr">
                <th className="month">Employee Name</th>
                <th className="month">Finacial Year</th>
                <th className="month">Target Amount</th>
              </tr>
            </thead>
            <tbody className="month">
              <tr className="montr">
                <td className="montd">{oneUserData?.user?.username}</td>
                <td className="montd">
                  {oneUserData?.salesTarget?.financialYear}
                </td>
                <td className="montd">{oneUserData?.targetAmount}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {oneUserData?.monthlytargetSet.length == 0 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div>
              <MaterialButton
                variant="gradient"
                color="dark"
                // disabled={totalTarget == totalamount ? false : true}
                // disabled={!checkAllFields()}
                onClick={handleAddMonthly}
              >
                Add Monthly Target
              </MaterialButton>
            </div>
          </div>
        ) : (
          <div className="tabel-target">
            <table>
              <thead>
                <tr>
                  <th>Sno</th>
                  <th>Month</th>
                  <th>Target Amount</th>
                </tr>
              </thead>
              <tbody>
                {oneUserData?.monthlytargetSet?.map((row, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{row.monthYear}</td>
                      <td
                        style={{
                          display: "flex",
                          marginTop: "5px",
                          alignItems: "center",
                        }}
                      >
                        {row.targetAmount || 0}

                        <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ViewMonthlyTarget;
